import PeopleRecords from './PeopleRecords';
export default PeopleRecords;
